// extracted by mini-css-extract-plugin
module.exports = {"filtersContainer":"styles_filtersContainer__1P--6","filterGrid":"styles_filterGrid__3vXwz","chip":"styles_chip__3bgvv","chipIcon":"styles_chipIcon__3WnNe"};